import { IApplicationState } from '../types/redux';

export const selectEstimation = (state: IApplicationState) => state.estimation;
